import apiClient from "@/api/client";

export interface VMReplica {
  id: number;
  vm_id: number;
  replica_node: string;
  replica_vmid: number;
  replication_mode: string;
  replication_schedule: string;
  proxmox_job_id: string | null;
  status:
    | "unsatisfied"
    | "pending"
    | "syncing"
    | "up_to_date"
    | "stale"
    | "failed";
  last_sync_at: string | null;
  last_error: string | null;
  created_at: string;
  updated_at: string;
}

export async function ensureReplica(vmId: number): Promise<VMReplica> {
  const { data } = await apiClient.post<VMReplica>(
    `/vms/${vmId}/ensure-replica`,
  );
  return data;
}
